import React from "react";
import { Card, Button, Badge } from "react-bootstrap";
import styles from "./VerificationRequest.module.css";
import { API_BASE_URL } from "../../../utils/constants";

const VerificationRequest = ({ request, onApprove, onReject, readonly }) => {
  const user = request.user || request; // допускаем разные формы ответа
  const mainPhoto = user.profileImage?.[0];
  const verifyImage = user.verifyImage;
  return (
    <Card className={styles.card}>
      <Card.Body>
        <div className={styles.user_info_wrapper}>
          {mainPhoto?.path && (
            <img
              src={API_BASE_URL + "/" + mainPhoto.name}
              alt=""
              className={styles.avatar}
            />
          )}
          <Card.Title className="mb-1">{user.name}</Card.Title>
        </div>
        <div className="small text-muted mb-2">{user.login}</div>
        <div className="small mb-2">
          <strong>Код верификации:</strong> {user?.code || "—"}
        </div>
        {verifyImage && (
          <Card.Img
            variant="top"
            src={API_BASE_URL + "/" + verifyImage}
            alt="verification"
            className={styles.image}
          />
        )}
        <Badge bg={user.isVerify ? "success" : "secondary"}>
          {user.isVerify ? "Уже верифицирован" : "Не верифицирован"}
        </Badge>
        {!readonly && (
          <div className="d-flex gap-2 mt-3">
            <Button size="sm" variant="success" onClick={onApprove}>
              Одобрить
            </Button>
            <Button size="sm" variant="outline-danger" onClick={onReject}>
              Отклонить
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default VerificationRequest;
